import type { MicroCMSQueries } from 'microcms-js-sdk';

export const useMicroCMSDetailParams = () => {
  const route = useRoute();
  const contentId = computed<string>(() => {
    const id = route.params.id;
    return Array.isArray(id) ? (id[0] ?? '') : id;
  });

  const hasDraftKey = computed<boolean>(() => {
    return Boolean(route.query.draftKey);
  });

  const draftKey = computed<string>(() => {
    return (hasDraftKey.value ? route.query.draftKey : '') as string;
  });

  const draftKeyQuery = computed<MicroCMSQueries>(() => {
    return hasDraftKey.value ? { draftKey: draftKey.value } : {};
  });

  return { contentId, draftKeyQuery, hasDraftKey, draftKey };
};
